import { render, staticRenderFns } from "./fade-in-transition.vue?vue&type=template&id=541dbb28&scoped=true&"
import script from "./fade-in-transition.vue?vue&type=script&lang=js&"
export * from "./fade-in-transition.vue?vue&type=script&lang=js&"
import style0 from "./fade-in-transition.vue?vue&type=style&index=0&id=541dbb28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541dbb28",
  null
  
)

export default component.exports